import { IVerb } from '../resources/istatement/verb';

export class Verbs {
	public static readonly ABANDONED: IVerb = {
		id: 'https://w3id.org/xapi/adl/verbs/abandoned',
		display: { 'en-US': 'abandoned' }
	};
	public static readonly ADJOURNED: IVerb = {
		id: 'http://id.tincanapi.com/verb/adjourned',
		display: { 'en-US': 'adjourned' }
	};
	public static readonly ANSWERED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/answered',
		display: { 'en-US': 'answered' }
	};
	public static readonly APPLAUDED: IVerb = {
		id: 'http://id.tincanapi.com/verb/applauded',
		display: { 'en-US': 'applauded' }
	};
	public static readonly ARRANGED: IVerb = {
		id: 'http://id.tincanapi.com/verb/arranged',
		display: { 'en-US': 'arranged' }
	};
	public static readonly ASKED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/asked',
		display: { 'en-US': 'asked' }
	};
	public static readonly ATTEMPTED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/attempted',
		display: { 'en-US': 'attempted' }
	};
	public static readonly ATTENDED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/attended',
		display: { 'en-US': 'attended' }
	};
	public static readonly BOOKMARKED: IVerb = {
		id: 'http://id.tincanapi.com/verb/bookmarked',
		display: { 'en-US': 'bookmarked' }
	};
	public static readonly CALLED: IVerb = {
		id: 'http://id.tincanapi.com/verb/called',
		display: { 'en-US': 'called' }
	};
	public static readonly CLOSED_SALE: IVerb = {
		id: 'http://id.tincanapi.com/verb/closed-sale',
		display: { 'en-US': 'closed sale' }
	};
	public static readonly COMMENTED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/commented',
		display: { 'en-US': 'commented' }
	};
	public static readonly COMPLETED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/completed',
		display: { 'en-US': 'completed' }
	};
	public static readonly CREATED_OPPORTUNITY: IVerb = {
		id: 'http://id.tincanapi.com/verb/created-opportunity',
		display: { 'en-US': 'created opportunity' }
	};
	public static readonly DEFINED: IVerb = {
		id: 'http://id.tincanapi.com/verb/defined',
		display: { 'en-US': 'defined' }
	};
	public static readonly DISABLED: IVerb = {
		id: 'http://id.tincanapi.com/verb/disabled',
		display: { 'en-US': 'disabled' }
	};
	public static readonly DISCARDED: IVerb = {
		id: 'http://id.tincanapi.com/verb/discarded',
		display: { 'en-US': 'discarded' }
	};
	public static readonly DOWNLOADED: IVerb = {
		id: 'http://id.tincanapi.com/verb/downloaded',
		display: { 'en-US': 'downloaded' }
	};
	public static readonly EARNED: IVerb = {
		id: 'http://id.tincanapi.com/verb/earned',
		display: { 'en-US': 'earned' }
	};
	public static readonly ENABLED: IVerb = {
		id: 'http://id.tincanapi.com/verb/enabled',
		display: { 'en-US': 'enabled' }
	};
	public static readonly ENTERED_FRAME: IVerb = {
		id: 'http://id.tincanapi.com/verb/frame/entered',
		display: { 'en-US': 'entered frame' }
	};
	public static readonly ESTIMATED_DURATION: IVerb = {
		id: 'http://id.tincanapi.com/verb/estimated-duration',
		display: { 'en-US': 'estimated duration' }
	};
	public static readonly EXITED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/exited',
		display: { 'en-US': 'exited' }
	};
	public static readonly EXITED_FRAME: IVerb = {
		id: 'http://id.tincanapi.com/verb/frame/exited',
		display: { 'en-US': 'exited frame' }
	};
	public static readonly EXPECTED: IVerb = {
		id: 'http://id.tincanapi.com/verb/expected',
		display: { 'en-US': 'expected' }
	};
	public static readonly EXPERIENCED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/experienced',
		display: { 'en-US': 'experienced' }
	};
	public static readonly EXPIRED: IVerb = {
		id: 'http://id.tincanapi.com/verb/expired',
		display: { 'en-US': 'expired' }
	};
	public static readonly FAILED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/failed',
		display: { 'en-US': 'failed' }
	};
	public static readonly FOCUSED: IVerb = {
		id: 'http://id.tincanapi.com/verb/focused',
		display: { 'en-US': 'focused' }
	};
	public static readonly HIRED: IVerb = {
		id: 'http://id.tincanapi.com/verb/hired',
		display: { 'en-US': 'hired' }
	};
	public static readonly INITIALIZED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/initialized',
		display: { 'en-US': 'initialized' }
	};
	public static readonly IMPORTED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/imported',
		display: { 'en-US': 'imported' }
	};
	public static readonly INTERACTED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/interacted',
		display: { 'en-US': 'interacted' }
	};
	public static readonly INTERVIEWED: IVerb = {
		id: 'http://id.tincanapi.com/verb/interviewed',
		display: { 'en-US': 'interviewed' }
	};
	public static readonly LAUNCHED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/launched',
		display: { 'en-US': 'launched' }
	};
	public static readonly LOGGED_IN: IVerb = {
		id: 'https://w3id.org/xapi/adl/verbs/logged-in',
		display: { 'en-US': 'logged-in' }
	};
	public static readonly LOGGED_OUT: IVerb = {
		id: 'https://w3id.org/xapi/adl/verbs/logged-out',
		display: { 'en-US': 'logged-out' }
	};
	public static readonly LAUGHED: IVerb = {
		id: 'http://id.tincanapi.com/verb/laughed',
		display: { 'en-US': 'laughed' }
	};
	public static readonly MARKED_AS_UNREAD: IVerb = {
		id: 'http://id.tincanapi.com/verb/marked-unread',
		display: { 'en-US': 'marked as unread' }
	};
	public static readonly MASTERED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/mastered',
		display: { 'en-US': 'mastered' }
	};
	public static readonly MENTIONED: IVerb = {
		id: 'http://id.tincanapi.com/verb/mentioned',
		display: { 'en-US': 'mentioned' }
	};
	public static readonly MENTORED: IVerb = {
		id: 'http://id.tincanapi.com/verb/mentored',
		display: { 'en-US': 'mentored' }
	};
	public static readonly PASSED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/passed',
		display: { 'en-US': 'passed' }
	};
	public static readonly PAUSED: IVerb = {
		id: 'https://w3id.org/xapi/adl/verbs/paused',
		display: { 'en-US': 'paused' }
	};
	public static readonly PERFORMED_OFFLINE: IVerb = {
		id: 'http://id.tincanapi.com/verb/performed-offline',
		display: { 'en-US': 'performed offline' }
	};
	public static readonly PERSONALIZED: IVerb = {
		id: 'http://id.tincanapi.com/verb/personalized',
		display: { 'en-US': 'personalized' }
	};
	public static readonly PLAYED: IVerb = {
		id: 'https://w3id.org/xapi/adl/verbs/played',
		display: { 'en-US': 'played' }
	};
	public static readonly PREFERRED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/preferred',
		display: { 'en-US': 'preferred' }
	};
	public static readonly PREVIEWED: IVerb = {
		id: 'http://id.tincanapi.com/verb/previewed',
		display: { 'en-US': 'previewed' }
	};
	public static readonly PROGRESSED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/progressed',
		display: { 'en-US': 'progressed' }
	};
	public static readonly PROMOTED: IVerb = {
		id: 'http://id.tincanapi.com/verb/promoted',
		display: { 'en-US': 'promoted' }
	};
	public static readonly RATED: IVerb = {
		id: 'http://id.tincanapi.com/verb/rated',
		display: { 'en-US': 'rated' }
	};
	public static readonly REGISTERED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/registered',
		display: { 'en-US': 'registered' }
	};
	public static readonly REPLIED: IVerb = {
		id: 'http://id.tincanapi.com/verb/replied',
		display: { 'en-US': 'replied' }
	};
	public static readonly REPLIED_TO_TWEET: IVerb = {
		id: 'http://id.tincanapi.com/verb/replied-to-tweet',
		display: { 'en-US': 'replied to tweet' }
	};
	public static readonly REQUESTED_ATTENTION: IVerb = {
		id: 'http://id.tincanapi.com/verb/requested-attention',
		display: { 'en-US': 'requested attention' }
	};
	public static readonly RESPONDED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/responded',
		display: { 'en-US': 'responded' }
	};
	public static readonly RESUMED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/resumed',
		display: { 'en-US': 'resumed' }
	};
	public static readonly RETWEETED: IVerb = {
		id: 'http://id.tincanapi.com/verb/retweeted',
		display: { 'en-US': 'retweeted' }
	};
	public static readonly REVIEWED: IVerb = {
		id: 'http://id.tincanapi.com/verb/reviewed',
		display: { 'en-US': 'reviewed' }
	};
	public static readonly SATISFIED: IVerb = {
		id: 'https://w3id.org/xapi/adl/verbs/satisfied',
		display: { 'en-US': 'satisfied' }
	};
	public static readonly SCORED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/scored',
		display: { 'en-US': 'scored' }
	};
	public static readonly SECURED: IVerb = {
		id: 'http://id.tincanapi.com/verb/secured',
		display: { 'en-US': 'secured' }
	};
	public static readonly SEEKED: IVerb = {
		id: 'https://w3id.org/xapi/adl/verbs/seeked',
		display: { 'en-US': 'seeked' }
	};
	public static readonly SELECTED: IVerb = {
		id: 'http://id.tincanapi.com/verb/selected',
		display: { 'en-US': 'selected' }
	};
	public static readonly SHARED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/shared',
		display: { 'en-US': 'shared' }
	};
	public static readonly SKIPPED: IVerb = {
		id: 'http://id.tincanapi.com/verb/skipped',
		display: { 'en-US': 'skipped' }
	};
	public static readonly SUSPENDED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/suspended',
		display: { 'en-US': 'suspended' }
	};
	public static readonly TALKEDWITH: IVerb = {
		id: 'http://id.tincanapi.com/verb/talked-with',
		display: { 'en-US': 'talkedwith' }
	};
	public static readonly TERMINATED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/terminated',
		display: { 'en-US': 'terminated' }
	};
	public static readonly TWEETED: IVerb = {
		id: 'http://id.tincanapi.com/verb/tweeted',
		display: { 'en-US': 'tweeted' }
	};
	public static readonly UNFOCUSED: IVerb = {
		id: 'http://id.tincanapi.com/verb/unfocused',
		display: { 'en-US': 'unfocused' }
	};
	public static readonly UNREGISTERED: IVerb = {
		id: 'http://id.tincanapi.com/verb/unregistered',
		display: { 'en-US': 'unregistered' }
	};
	public static readonly VOIDED: IVerb = {
		id: 'http://adlnet.gov/expapi/verbs/voided',
		display: { 'en-US': 'voided' }
	};
	public static readonly VOTED_DOWN: IVerb = {
		id: 'http://id.tincanapi.com/verb/voted-down',
		display: { 'en-US': 'voted down' }
	};
	public static readonly VOTED_UP: IVerb = {
		id: 'http://id.tincanapi.com/verb/voted-up',
		display: { 'en-US': 'voted up' }
	};
	public static readonly VIEWED: IVerb = {
		id: 'http://id.tincanapi.com/verb/viewed',
		display: { 'en-US': 'viewed' }
	};
	public static readonly WAIVED: IVerb = {
		id: 'https://w3id.org/xapi/adl/verbs/waived',
		display: { 'en-US': 'waived' }
	};
}
